$(document).ready(function () {

    if( $('.page-contatti').length > 0 ) {
        initMap();
    }
    if ($('#formContatti').length > 0) {
        $('#formContatti .form-control').on('keyup', function () {

            if($(this).closest('.form-group').hasClass('has-error')) {
                $(this).closest('.form-group').find('label[data-role="has-error"]').remove();
            }
            $(this).closest('.form-group').removeClass("has-error");

            if (
                $('#formContatti [data-role="nome"]').val() != '' &&
                $('#formContatti [data-role="oggetto"]').val() != '' &&
                $('#formContatti [data-role="messaggio"]').val() != ''
                //&& ($('#formContatti [data-role="email"]').val() != '' || $('#formContatti [data-role="cellulare"]').val() != '')
            ) {
                $('#frmContattiSubmit').removeClass("disabled");
            } else {
                $('#frmContattiSubmit').addClass("disabled");
            }
        });
        $('#frmContattiSubmit').on('click', function() {
            if ($(this).hasClass('disabled') == true) {
                $.each($('#formContatti .form-control'), function (k,v) {
                    if ($(this).val() == '') {
                        $(this).closest('.form-group').addClass("has-error");
                    }
                });
            } else {
                $.each($('#formContatti .form-group.has-error'), function (k,v) {
                    $(this).removeClass("has-error");
                    $(this).find('label[data-role="has-error"]').remove();

                });
                $('#frmContattiSubmit').addClass("disabled");
                $('#frmContattiSubmit').html('<i class="fas fa-spinner fa-spin" aria-hidden="true"></i>&nbsp;Attendi...')
                var postData = getValueByContainer('#formContatti');
                ajaxRequest(base_url+'contatti', postData).then( function (res) {


                    if (res.result) {
                        $('#frmContattiSubmit').html('<i class="fas fa-paper-plane" aria-hidden="true"></i>&nbsp;Invia')
                        $('#formContatti input.form-control').each( function (k,v) {
                            if ($(this).prop('disabled') == false) {
                                $(this).val('');
                            }
                        });
                        $('#formContatti textarea.form-control').val('');
                        $('#formContatti').prepend(saccessAnimation());
                        scrollTo('#formContatti .success-checkmark');
                        setTimeout(function () {
                            $('.success-send-request').remove();
                        },5000);

                    } else {

                        $.each(res.data, function (k,v) {
                            if ($('#formContatti input[name="'+k+'"]').length > 0) {
                                $('#formContatti input[name="'+k+'"]').closest('.form-group').addClass('has-error').append(
                                    '<label class="" data-role="has-error">'+v.join(', ')+'</label>'
                                );
                            }
                        });
                        scrollTo('#formContatti .has-error:first');


                        $('#frmContattiSubmit').html('<i class="fas fa-times" aria-hidden="true"></i>&nbsp;Riprova...')
                    }

                    $('#frmContattiSubmit').removeClass("disabled");
                }).catch(function (err) {
                    console.log(err);
                });
            }
        });
    }
});
